import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ disabled, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('el-switch')
    child.attrs = {
      ...child.attrs,
      disabled
    }
    this.children = [child]
  }
}
